// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__186j7","inner":"Footer_inner__1t5ZT","nextIcon":"Footer_nextIcon__2cMT1","innerLeft":"Footer_innerLeft__3a11Y"};